import { FC, HTMLAttributes } from 'react';
import classNames from 'classnames';
import st from './Icon.module.scss';

interface IIconProps extends HTMLAttributes<HTMLOrSVGElement> {
	name: IconTypes;
	width?: string | number;
	height?: string | number;
}

export type IconTypes = 'mfc' | 'info' | 'shevronLeft' | 'plus' | 'scan';

const Icon: FC<IIconProps> = ({
	name,
	className,
	width = 32,
	height = 32,
	...otherProps
}) => {
	return (
		<svg
			className={classNames(st.rdc_icon, className, `rdc_icon-${name}`)}
			style={{ width, height }}
			{...otherProps}
		>
			<use
				xlinkHref={`${process.env.PUBLIC_URL}/images/IconSprite.svg#${name}`}
			></use>
		</svg>
	);
};

export default Icon;
